import styled from 'styled-components/macro';

export const ViewPort = styled.div`
  display: flex;
  justify-content: center;
`;

export const Poster = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  max-width: 1000px;
  text-align: center;
`;

export const Header = styled.div`
  padding: 1rem 0;
`;

export const Body = styled.div`
  height: 100%;
  padding: 2rem 0;
`;

export const Heading = styled.h1`
  font-size: 6rem;
  margin-bottom: 2rem;
`;

export const SubHeading = styled.h3`
  font-size: 4rem;
  margin-bottom: 2rem;
`;

export const Instructions = styled.p`
  font-size: 2rem;
  margin: 2rem 0;
`;

export const ManualLink = styled.p`
  font-size: 1.6rem;
  margin-top: 2rem;
`;

export const Footer = styled.div`
  padding: 1rem;

  @media print {
    display: none;
  }
`;

export const ButtonContainer = styled.div`
  text-align: right;

  button:not(:first-child) {
    margin-left: 6px;
  }
`;
